<header message="{{ 'LOGIN.WELCOME' | translate:locale.language }}"></header>

<div class="occon-login-body">
  <div class="occon-login-columns animated fadeInDown">
    <div class="row white-bg occon-login-panel">
      <div class="login-panel-part">
        <div class="occon-login-info">
          <div class="occon-login-support">
            <h4>{{ 'LOGIN.SUPPORT' | translate:locale.language }}</h4>
            <div>
              <fa-icon icon="clock" size="4x"></fa-icon>
              <span>
                {{ 'LOGIN.OFFICE_HOURS' | translate:locale.language }}:<br>
                8:00 - 17:00 CET
              </span>
            </div>
            <div>
              <fa-icon icon="at" size="4x"></fa-icon>
              <span>
                {{ 'LOGIN.MAIL' | translate:locale.language }}:<br>
                support@occon.de
              </span>
            </div>
            <div>
              <fa-icon icon="phone" size="3x"></fa-icon>
              <span>
                {{ 'LOGIN.PHONE' | translate:locale.language }}:<br>
                +49 621 5968 3262 - 10
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="login-part-separator">
        <div class="separator-left"></div>
        <div class="separator-right"></div>
        <div class="login-icon">
          <div class="outer">
            <fa-icon size="2x" icon="sign-in-alt"></fa-icon>
          </div>
        </div>
      </div>
      <div class="login-panel-part">
        <div *ngIf="!registerUser" class="ibox-content no-top-border">
          <div class="label-and-input">
            <label for="authoritySelection">{{ 'LOGIN.SELECT_AUTHORITY_LABEL' | translate:locale.language }}</label>
            <ng-select id="authoritySelection"
                       [items]="authorities"
                       [clearable]="false"
                       [searchable]="false"
                       [bindLabel]="'name'"
                       [bindValue]="'authorityId'"
                       appendTo="body"
                       (change)="authorityChanged()"
                       [(ngModel)]="currentSettingsId"></ng-select>
          </div>
          <div *ngIf="currentUser" class="user-sso-info" style="text-align: center; margin-top: 5px">
            <p
              style="width: 100%; display: block; border-radius: 500px; background-color: lightgray; height: 30px; padding-top: 5px">
              {{ 'LOGIN.LOGGED_IN_AS' | translate:locale.language }} {{currentUser.profile.email}}</p>
            <button style="width: 100%; margin-top: 5px" class="btn btn-success"
                    (click)="loginToClient()">{{ 'LOGIN.ENTER_NOCCO_BUTTON' | translate:locale.language }}
            </button>
            <button style="width: 100%; margin-top: 5px" class="btn btn-default"
                    (click)="logout()">{{ 'GENERAL.LOGOUT' | translate:locale.language }}</button>
          </div>
          <div *ngIf="!currentUser && currentSettingsId && currentSettingsId !== ''" class="user-sso-info"
               style="text-align: center; margin-top: 5px">
            <button style="width: 100%; margin-top: 5px" class="btn btn-success"
                    (click)="startLogin()">{{ 'LOGIN.LOGIN_USING_BUTTON' | translate:locale.language }} {{currentSettingsName}}</button>
          </div>
          <div class="user-sso-info">
            <button style="width: 100%; margin-top: 10px" class="btn btn-default" (click)="backToLogin()">
              {{'REGISTRATION.NAVIGATION.MAINPAGE' | translate:locale.language}}
            </button>
          </div>
        </div>
        <div *ngIf="registerUser" class="ibox-content no-top-border">
          <div class="label-and-input">
            <label for="register-first-name">{{ 'REGISTRATION.FIRSTNAME' | translate:locale.language }}</label>
            <input class="form-control" (input)="checkRegisterUserValid()" type="text" id="register-first-name"
                   [(ngModel)]="userFirstName">
          </div>
          <div class="label-and-input">
            <label for="register-last-name">{{ 'REGISTRATION.LASTNAME' | translate:locale.language }}</label>
            <input class="form-control" (input)="checkRegisterUserValid()" type="text" id="register-last-name"
                   [(ngModel)]="userLastName">
          </div>
          <div class="label-and-input">
            <label for="register-gender">{{ 'REGISTRATION.GENDER' | translate:locale.language }}</label>
            <ng-select id="register-gender"
                       [items]="genderList"
                       [clearable]="false"
                       [searchable]="false"
                       [bindLabel]="'name'"
                       [bindValue]="'id'"
                       (change)="checkRegisterUserValid()"
                       appendTo="body"
                       [(ngModel)]="userGender"></ng-select>
          </div>
          <div class="user-sso-info"
               style="text-align: center; margin-top: 5px">
            <button style="width: 100%; margin-top: 5px" class="btn btn-success"
                    (click)="registerUserInNOCCO()">{{ 'LOGIN.CONFIRM_NEW_ACCOUNT_BUTTON' | translate:locale.language }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <br>
  </div>
</div>

<footer></footer>
